import apiClient from './apiClient';

// PrdProduct interface matching backend model
export interface PrdProduct {
  prd_mid: number;
  full_prd_code: string;
  prd_code: string;
  prd_name: string;
  prd_sort: string;
  prd_sort_child: string;
  prd_type: number;
  unit: string;
  pcs_code: string;
  processing: string;
  speci: string;
  component: string;
  full_name: string;
  full_name_in: string;
  org: string;
  u_width_c: number;
  u_width_i: number;
  f_width_c: number;
  f_width_i: number;
  wight_m: number;
  wight_y: number;
  height: number;
  diff_width: number;
  diff_wight: number;
  color_code: string;
  color: string;
  is_active: boolean;
  is_valid: boolean;
  c_user: string;
  c_date: string | null;
  u_user: string;
  u_date: string | null;
  memo: string;
  jws_details?: PrdProductJWS[];
  busi_details?: PrdProductBusi[];
  bm_details?: PrdProductBm[];
  cf_details?: PrdProductCF[];
}

export interface PrdProductJWS {
  id?: number;
  prd_mid?: number;
  jw_type: string;
  prd_cf: string;
  prd_spec: string;
  prd_gz: string;
  prd_ysb: number;
}

export interface PrdProductBusi {
  busi_did?: number;
  prd_mid?: number;
  composition: string;
  spec: string;
  width: string;
  weight: string;
  drop: string;
  func: string;
  process: string;
  remark: string;
  fin: string;
  wash_details?: PrdProductWash[];
}

export interface PrdProductWash {
  id?: number;
  busi_did?: number;
  wl_code: string;
  wsh_type: string;
  c_name: string;
}

export interface PrdProductBm {
  id?: number;
  prd_mid?: number;
  cloth_kind: string;
  prd_code: string;
  speci: string;
  component: string;
  processing: string;
}

export interface PrdProductCF {
  id?: number;
  prd_mid?: number;
  comp: string;
  perc: number;
}

export interface CreateRequest {
  master: Partial<PrdProduct>;
  jws_details?: PrdProductJWS[];
  busi_details?: PrdProductBusi[];
  bm_details?: PrdProductBm[];
  cf_details?: PrdProductCF[];
}

export interface ListResponse {
  data: PrdProduct[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/product-master';

const productMasterApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (id: number): Promise<PrdProduct> => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data;
  },

  create: async (data: CreateRequest): Promise<PrdProduct> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (id: number, data: CreateRequest): Promise<PrdProduct> => {
    const res = await apiClient.put(`${BASE}/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};

export default productMasterApi;
